
<!--
NOTE:
    Make sure resizeContainers is true ONLY when NOT the header toolbar (!inHeader).

      [resizeContainers]="!inHeader && (maximizeTitle || hideToolbarButtons)"

    - Seeing odd behaviour when used in the header toolbar.
    - header toolbar is reused a lot throught the app. maybe too many changes for sohoxi to keep up with??? not sure,
    [blockUI]="true"
-->
@if (asOfDateMode || proxyModeView || viewArchiveMode || xlFileUploadInProgress || ((secSessionDebugMode || dbSessionDebugMode || listCostReportMode) && inHeader)) {

  <span class="banner-button-span">
    @if (asOfDateMode) {
      <button
        id="as-of-date-button"
        class="as-of-date-button top-toolbar-button"
        data-automation-id="lm-banner-as-of-date-button"
        (click)="clearAsOfDate($event)"
        soho-button icon="{{drillAroundWindow ? null : 'close'}}"
        isToggle="true"
        soho-tooltip [content]="drillAroundWindow ? null : clearAsOfDateTooltip">
        <span class="audible">{{asOfDateTitle}}</span>
        <span class="lm-banner-button-text">{{asOfDateTitle}}</span>
      </button>
  }
  @if (viewArchiveMode) {
    <button
      id="view-archive-button"
      class="view-archive-button top-toolbar-button orange-banner-button"
      data-automation-id="lm-banner-archive-mode-button"
      (click)="quitArchiveView($event)"
      soho-button icon="{{drillAroundWindow ? null : 'close'}}"
      isToggle="true"
      soho-tooltip [content]="drillAroundWindow ? null : archiveModeTooltip">
        <span class="audible">{{viewArchiveTitle}}</span>
        <span class="lm-banner-button-text">{{viewArchiveTitle}}</span>
      </button>
    }
    @if (dbSessionDebugMode && inHeader) {
      <button
      id="db-session-debug-mode-button"
      class="db-session-debug-mode-button top-toolbar-button"
      data-automation-id="lm-banner-db-session-debug-button"
      title="{{dbSessionDebugModeTooltip}}"
      soho-button icon="close" isToggle="true"
      soho-tooltip [content]="dbSessionDebugModeTooltip"
      (click)="quitDBSessionDebugMode()">
        <span class="audible">{{dbSessionDebugTitle}}</span>
        <span class="lm-banner-button-text">{{dbSessionDebugTitle}}</span>
      </button>
    }
    @if (secSessionDebugMode && inHeader) {
      <button
      id="sec-session-debug-mode-button"
      class="sec-session-debug-mode-button top-toolbar-button"
      data-automation-id="lm-banner-sec-session-debug-button"
      title="{{secSessionDebugModeTooltip}}"
      soho-button icon="close" isToggle="true"
      soho-tooltip [content]="secSessionDebugModeTooltip"
      (click)="quitSecSessionDebugMode()">
        <span class="audible">{{secDebugActiveString}}</span>
        <span class="lm-banner-button-text">{{secDebugActiveString}}</span>
    </button>
  }
  @if (proxyModeView && inHeader) {
    <button
      id="proxyMode-button"
      class="proxy-mode-button top-toolbar-button"
      data-automation-id="lm-banner-proxyMode-button"
      title="{{proxyModeTooltip}}"
      soho-button icon="{{drillAroundWindow ? null : 'close'}}"
      isToggle="true"
      soho-tooltip [content]="drillAroundWindow ? null : proxyModeTooltip"
      (click)="quitProxyMode()">
        <span class="audible">{{proxyBannerTitle}}</span>
        <span class="lm-banner-button-text">{{proxyBannerTitle}}</span>
    </button>
  }
  @if (listCostReportMode && inHeader) {
    <button
          id="db-list-cost-report-mode-button"
          class="sec-session-debug-mode-button top-toolbar-button"
          title="{{dbListCostReportModeTooltip}}"
          soho-button icon="close" isToggle="true"
          soho-tooltip [content]="dbListCostReportModeTooltip"
          (click)="quitListCostReportMode()">
      <span class="audible">{{costReportActiveString
        }}</span>
        {{costReportActiveString}}
    </button>
  }
  @if (xlFileUploadInProgress) {
    <button
        id="upload-inprogress-button"
        class="upload-inprogress-button top-toolbar-button blue-banner-button"
        data-automation-id="lm-banner-upload-inprogress-button"
        (click)="showUploadStatus()"
        soho-button icon="chevron-down"
        lm-tooltip [content]="xlFileUploadTitle">
        <span class="audible">{{xlFileUploadTitle}}</span>
        <span class="lm-banner-button-text">{{xlFileUploadTitle}}</span>
    </button>
  }
  </span>
}

<soho-toolbar-flex
  #SohoToolbarComponent
    soho-busyindicator
    [text]="' '"
    [overlayOnly]="true"
    [transparentOverlay]="true"
    [timeToComplete]="500"
    [moreMenuBeforeOpenFunction]="moreMenuSettings?.beforeOpen"
    class="flex-toolbar-main-app-content "
    [ngClass]="{'disableBackground': disableToolbar, 'in-overlay': isInOverlay}"
    (selected)="onFlexItemSelected($event)"
    [attributes]="toolbarAttributes"
    role="toolbar"
    aria-labelledby="!inHeader ? lm-{{automationId}}-toolbar-audible : null"
>
  @if (!inHeader) {  
    <span class="audible" id="lm-{{automationId}}-toolbar-audible">{{ sectionTitle }}</span>
  }
  @if (!hideToolbarTitles) {


    @if (inHeader) {

      <!-- in header -->
      <soho-toolbar-flex-section>
        @if (!hideNavBar) {

          <button #menuTrigger
            id="app-menu-trigger"
            data-automation-id="lm-toolbar-app-menu-trigger"
            [ngStyle]="{'vertical-align': 'middle', 'padding': '0px'}"
            class="btn-icon application-menu-trigger"
            type="button"
            soho-tooltip [content]="!isMobileDevice ? menuToolTip : undefined" [showOnKeyboardFocus]="false"
            (click)="onAppMenuTrigger($event)">
              <span class="audible">{{menuNavigationString}}</span>
              @if (!goBack) {
                <svg soho-icon [icon]="'menu'"></svg>
              }
              @if (goBack) {
                <svg soho-icon [icon]="'arrow-left'"></svg>
              }
          </button>

        }
      </soho-toolbar-flex-section>
      <soho-toolbar-flex-section
        [isTitle]="true"
        [isTitleFavor]="favorTitle"
        [class.lm-mobile-called-out-only]="showCalledOutMenuButton">
        <h1 #pageTitle class='titleHeader' tabindex="-1" lm-live-region [liveRegionConfig]="headerTitleLiveConfig">
          @if (sectionTitle) {

            <span
              attr.id={{toolbarTitleId}}
              attr.data-automation-id="lm-{{automationId}}-toolbar-title"
              class='page-title lm-header-title-content'
              soho-tooltip content="{{sectionTitle | escape}}" [placement]="'bottom'"
              aria-hidden="true"
            >{{sectionTitle}}</span>
          }
          @if (showMustache) {

                @if(isReportAsOfDate && !asOfDateMode) {
                    <header attr.data-automation-id="lm-{{automationId}}-mustache-text" class="lm-list-header-record-count result-set-in-header"
                      soho-tooltip [content]="mustacheText">
                      {{mustacheText}}
                      <button soho-button="icon" icon="edit" class="btn btn-icon lm-report-asofdate-button" attr.data-automation-id="lm-{{automationId}}-reportasofdate-button" (click)="updateReportAsOfDate()">
                        <span class="audible">{{ 'EditAsOfDateValue' | translate }}</span>
                      </button>
                    </header>
                } @else {
                    <header attr.data-automation-id="lm-{{automationId}}-mustache-text" class="lm-list-header-record-count result-set-in-header"
                      soho-tooltip [content]="mustacheText">{{mustacheText}}</header>
                }
          }
        </h1>
      </soho-toolbar-flex-section>

    }

    @if (!inHeader) {

      <!-- if not in the header -->

      <!--todo ppatton - kludge for now - need markup/style from soho so that the icon will be correctly vertically aligned.-->
      @if (showListDetailBackButton) {

        <soho-toolbar-flex-section>
          <div class="lm-list-detail-back-button-container">
            <button soho-button="btn-icon"
                class="btn-icon list-detail-back-button secondary"
                [style.vertical-align]="'top'"
                [icon]="'bullet-steps'"
                soho-tooltip [content]="'Show Filter List'"
            ></button>
          </div>
        </soho-toolbar-flex-section>

      }

      @if (showOverlayBackButton) {

        <soho-toolbar-flex-section>
          <div class="lm-overlay-back-button">
            <button soho-button="icon"
                class="lm-overlay-back"
                [icon]="'arrow-left'"
                soho-tooltip [content]="'Back'"
                (click)="overlayBackClick()"
            ></button>
          </div>
        </soho-toolbar-flex-section>

}

      <soho-toolbar-flex-section
        [isTitle]="true"
        [isTitleFavor]="favorTitle"
        [class.lm-overlay-title]="isInOverlay"
        [class.lm-mobile-called-out-only]="showCalledOutMenuButton">
        <h2>
          <span
              attr.id="{{toolbarTitleId}}"
              attr.data-automation-id="lm-{{automationId}}-toolbar-title"
              [attr.aria-label]="sectionTitle || ''"
              [class.mingle-inbox-title]="isMingleInbox"
              soho-tooltip content="{{sectionTitle}}">{{sectionTitle}}</span>

          @if (showMustache) {
            <header
              attr.data-automation-id="lm-{{automationId}}-mustache-text"
              class="lm-list-header-record-count result-set-not-in-header"
              [attr.aria-label]="mustacheText || ''"
              soho-tooltip [content]="mustacheText">{{mustacheText}}</header>
          }

        </h2>
      </soho-toolbar-flex-section>


}


}
  @if (searchField) {

    <soho-toolbar-flex-section [isSearch]="true">
      <!-- LMCLIENT-40456: adding 'has-collapse-button' before jQuery control does to fix shifting issue -->
<!--      attr.data-automation-id="lm-{{automationId}}-toolbar-searchfield"-->
      <form (ngSubmit)="fireSearchEvent($event)" class="lm-searchfield-form">
      <span
          id="{{toolbarId}}_searchfield"
          [ngClass]="{'searchfield-wrapper toolbar-searchfield-wrapper': true, 'has-collapse-button': searchField.collapsible}"
      >
        <input soho-toolbar-flex-searchfield
            placeholder="{{searchField?.label}}"
            lm-tooltip content="{{searchField?.label}}"
            enterkeyhint="search"
            [(ngModel)]="searchField.value"
            [ngModelOptions]="{standalone: true}"
            [options]="searchField"
            [clearable]="true"
            [attr.disabled]="disabled ? 'disabled' : null"
            (cleared)="fireClearSearchEvent($event)"
        />
      </span>
      </form>
    </soho-toolbar-flex-section>

}

  @if (showButtonSet) {

    <soho-toolbar-flex-section [isButtonSet]="true"
      [class.lm-overlay-toolbar]="isInOverlay"
      [style.display]="isCreateReportMode ? 'none' : 'block'">
    <!-- toolbar buttons -->
        @for (b of flexButtonSetButtons; track trackButton($index, b)) {

        @if (displayAsLink(b)) {

          <a href="javascript:void(0);" attr.data-automation-id="{{b.automationId}}" class="hyperlink" attr.data-action-reference="{{stringifyJson(b?.actionReference)}}">View All</a>

}

<!--      attr.attributes="[{ name: 'data-automation-id', value: 'lm-{{b?.automationId}}-toolbar-button' }]"-->
      @if (isCustomButton(b) && !displayAsLink(b)) {

        @if (!isCustomMenuButton(b)) {

          <button soho-button="btn"
              attr.id="{{elementId(b?.customToolbarButtonInfo?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              [icon]="b?.customToolbarButtonInfo?.icon"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              attr.data-custom-toolbar-button-info="{{stringifyJson(b?.customToolbarButtonInfo)}}"
              soho-tooltip [content]="b?.customToolbarButtonInfo?.resolvedTooltip || ''"
          >{{b?.customToolbarButtonInfo?.text}}@if (!(!!b?.customToolbarButtonInfo?.text)) {

              <span class="audible">{{b?.customToolbarButtonInfo?.tooltip}}</span>

}
          </button>

}

        @if (isCustomMenuButton(b)) {

          <button
              soho-menu-button
              attr.id="{{elementId(b?.customToolbarButtonInfo?.id)}}"
              attr.data-automation-id="lm-{{automationId}}-{{b?.customToolbarButtonInfo?.id}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{automationId}}-{{b?.customToolbarButtonInfo?.id}}-toolbar-button'}]"
              [hideMenuArrow]="b?.customToolbarButtonInfo?.hideMenuArrow"
              attr.data-custom-toolbar-button-info="{{stringifyJson(b?.customToolbarButtonInfo)}}"
              [icon]="b?.customToolbarButtonInfo?.icon"
              menu="{{b?.customToolbarButtonInfo?.id}}_menu"
              [autoFocus]="true"
              [attachToBody]="true"
              [removeOnDestroy]="true"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip
              [content]="b?.customToolbarButtonInfo?.resolvedTooltip || ''"
          >
            <span>{{b?.customToolbarButtonInfo?.text}}</span>
            @if (!(!!b?.customToolbarButtonInfo?.text)) {

              <span class="audible">{{b?.customToolbarButtonInfo?.tooltip}}</span>

}
          </button>

          <div class="popupmenu-wrapper bottom" role="application" aria-hidden="true">
            <ul class="popupmenu is-selectable" id="{{b?.customToolbarButtonInfo?.id}}_menu">
              @for (menuItem of b?.customToolbarButtonInfo?.menu; track menuItem.id) {
<li

                  id="{{menuIdV1(menuItem?.id)}}"
                  [ngClass]="{
                  'separator': menuItem.customToolbarButtonInfo?.type === separator,
                  'is-disabled': menuItem.state?.disabled || disabled,
                  'is-checked': menuItem?.isChecked}"
                  title="{{b?.customToolbarButtonInfo?.tooltip}}"
              >
                <!-- Only put the a in if not a separator. If this is here, we get a blank value in the list -->
                @if (menuItem.customToolbarButtonInfo?.type !== separator) {

                  <a
                          href="#"
                          id="{{menuIdV2(menuItem?.id)}}"
                          attr.data-custom-toolbar-button-info="{{stringifyJson(menuItem?.customToolbarButtonInfo)}}"
                          title="{{menuItem?.customToolbarButtonInfo?.tooltip}}"
                  >{{menuItem?.customToolbarButtonInfo?.text}}</a>

}
              </li>
}
            </ul>
          </div>

}


}
      @if (!isCustomButton(b) && !displayAsLink(b)) {

        <!-- The ngClass is needed here to maintain the order of classes. Without this, css rules are breaking. Added for LMCLIENT-32061 -->
        @if (isDefaultButton(b)) {

          <button soho-button="btn"
              (click)="getActionDescription(b)"
              id="{{this.elementId(b?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"
              class="btn hide-focus has-tooltip {{testVersion1 ? b?.actionReference?.id : ''}}"
              [ngClass]="{'lm-flex-icon-button': b?.isIconOnly}"
              [isToggle]="b?.isToggle"
              [isTogglePressed]="b.state?.isPressed"
              [icon]="b?.icon"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.resolvedTooltip || ''"
          >
              <span lm-live-region [liveRegionConfig]="liveMessageSortAction">{{b?.actionReference?.label}}</span>
              @if (!(!!b?.actionReference?.label)) {

              <span class="audible">{{b?.actionReference?.tooltip}}</span>

              }
          </button>

        }

        @if (isMenuButton(b)) {

          <!-- The ngClass is needed here to maintain the order of classes. Without this, css rules are breaking. Added for LMCLIENT-32061 -->
          <button
              soho-menu-button
              attr.id="{{elementId(b?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              attr.action-ref-type="{{b?.actionReference?.id}}"
              attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"
              class="btn-menu hide-focus has-tooltip {{testVersion1 ? b?.actionReference?.id : ''}}"
              [ngClass]="{'lm-flex-icon-button': b?.isIconOnly}"
              [icon]="b?.icon"
              [menu]="b?.actionReference?.id + '_menu'"
              [attachToBody]="true"
              [autoFocus]="true"
              [removeOnDestroy]="true"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.resolvedTooltip || ''"
          >

            <span>{{b?.actionReference?.label}}</span>
            @if (!(!!b?.actionReference?.label)) {

              <span class="audible">{{b?.actionReference?.tooltip}}</span>

}
          </button>

          <div class="popupmenu-wrapper bottom" role="application" aria-hidden="true">
            <ul class="popupmenu" id="{{b?.actionReference?.id}}_menu">
              @for (menuItem of b.menu; track menuItem.id) {
                @if (menuItem.state?.visible !== false) {
                  <li

                    [ngClass]="{
                      'separator': menuItem.actionReference?.type === separator,
                      'is-disabled': menuItem.state?.disabled || disabled,
                      'is-checked': menuItem?.isChecked
                    }"
                    class="{{menuItem?.actionReference?.id}}"
                    title="{{menuItem?.actionReference?.tooltip}}"
                    id="{{menuIdV1(menuItem?.actionReference?.id)}}"
                  >
                    <!-- Only put the a in if not a separator. If this is here, we get a blank value in the list -->
<!--                id="{{menuItem?.actionReference?.id}}_anchor"-->
                  @if (menuItem.actionReference?.type !== separator) {

                    <a href="#"
                      attr.data-action-reference="{{stringifyJson(menuItem?.actionReference)}}"
                      title="{{menuItem?.actionReference?.tooltip}}"
                      attr.id="{{menuIdV2(menuItem?.id)}}"
                      attr.data-automation-id="lm-{{menuItem?.automationId}}-toolbar-menuitem"
                      attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{menuItem?.automationId}}-toolbar-menuitem'}]"
                      [attr.disabled]="menuItem.state?.disabled || disabled ? 'disabled' : null"
                    >{{menuItem?.actionReference?.label}}</a>
                  }
                  </li>
                }
              }
            </ul>
          </div>

}

        @if (isRelatedMenuButton(b)) {

          <!-- The ngClass is needed here to maintain the order of classes. Without this, css rules are breaking. Added for LMCLIENT-32061 -->
<!--          attr.data-automation-attributes="{'attributes': [{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]}"-->
          <button
            #relatedMenu
              soho-menu-button
              attr.id="{{elementId(b?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"
              class="btn-menu hide-focus has-tooltip {{testVersion1 ? b?.actionReference?.id : ''}}"
              [ngClass]="{'lm-flex-icon-button': b?.isIconOnly}"
              [icon]="b?.icon"
              [attachToBody]="true"
              [autoFocus]="true"
              [removeOnDestroy]="true"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.resolvedTooltip || ''"
          >
            <span>{{b?.actionReference?.label}}</span>
            @if (!(!!b?.actionReference?.label)) {

              <span class="audible">{{b?.actionReference?.tooltip}}</span>

}
          </button>
          @if (displayRelatedButtonPopupMenu(b)) {
<ul class="popupmenu" attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"></ul>
}

}

}

}
    </soho-toolbar-flex-section>

}
  @if (useEmptyMoreButton) {

    @if (!isInOverlay) {

      <soho-toolbar-flex-more-button [moreButtonId]="toolbarMoreButtonId"></soho-toolbar-flex-more-button>

}

} @else {

    @if (flexMoreButtons?.length > 0) {

<!--      attributes="[{'name': 'data-automation-id', 'value': 'lm-{{automationId}}-toolbar-more-button'}]"-->
      <soho-toolbar-flex-more-button
          [style.display]="isCreateReportMode ? 'none' : 'block'"
          attr.id="{{testVersion1 ? toolbarId + '_morebutton' : ''}}"
          [moreButtonId]="toolbarMoreButtonId"
          attr.data-automation-id="lm-{{automationId}}-toolbar-more-button"
      >
        <ul class="popupmenu">
          @if (moreMenuSettings?.beforeOpen) {

            <li>Placeholder</li>

}

          @if (!moreMenuSettings?.beforeOpen) {

            @for (menuItem of flexMoreButtons; track menuItem.id) {
<li

                class="btn {{testVersion1 ? menuItem?.customToolbarButtonInfo?.id : ''}}"
                title="{{menuItem?.customToolbarButtonInfo?.tooltip}}"
                [attr.disabled]="menuItem.state?.disabled || disabled ? 'disabled' : null"
                attr.data-custom-toolbar-button-info="{{stringifyJson(menuItem?.customToolbarButtonInfo)}}"
                attr.id="{{menuIdV1(menuItem?.customToolbarButtonInfo?.id)}}"
            >
              <a href="#"
                  attr.id="{{menuIdV2(menuItem?.customToolbarButtonInfo?.id)}}"
                  attr.data-custom-toolbar-button-info="{{stringifyJson(menuItem?.customToolbarButtonInfo)}}"
                  title="{{menuItem?.customToolbarButtonInfo?.tooltip}}"
              >{{menuItem?.customToolbarButtonInfo?.text}}</a>

            </li>
}

}
        </ul>
      </soho-toolbar-flex-more-button>

}

}

</soho-toolbar-flex>

@if (liveMessageSortAction?.liveMessage) {
<span
        lm-live-region
        [liveRegionConfig]="liveMessageSortAction"
></span>
}
